import React from 'react';
import { connect } from 'react-redux';
import { Redirect, useLocation, useRouteMatch } from "react-router-dom";
import { setFlowStatus, submitData } from '../actions/userData';
import Account from '../components/Account';
import { HOUSING_LINK, OTHER_INCOME_LINK, PROFILE_LINK, SOCIAL_BENEFITS_LINK } from '../components/flows/linkConstants';
import PortfolioFlow from '../components/interrogate/AssetFlow';
import ExpenseFlow from '../components/interrogate/ExpenseFlow';
import IncomeFlow from '../components/interrogate/IncomeFlow';
import OnboardingFlowView from '../components/interrogate/ProfileFlow';
import SocialSecurityFlow from '../components/interrogate/SocialSecurityFlow';
import CashFlow from '../components/ledger/CashFlow';
import Sidebar from '../components/sidebar/Sidebar';


const LLTabs = ({ flowStatus }) => {
    const { params } = useRouteMatch();
    const location = useLocation();

    let splitPath = location.pathname.split('/');
    let subTab = splitPath.length > 3 ? splitPath[3] : undefined;
    let flow = !subTab ? params.tab : subTab;
    let flowHasBeenVisited = flowStatus[flow];
    if (flow !== 'account' && !flowHasBeenVisited) return <Redirect to='/app/profile' />;

    switch (params.tab) {
        case 'profile':
            return <OnboardingFlowView />
        case 'expenses':
            return <ExpenseFlow next={SOCIAL_BENEFITS_LINK} previous={OTHER_INCOME_LINK} subTab={subTab} />
        case 'social-security':
            return <SocialSecurityFlow subTab={subTab} />
        case 'income':
            return <IncomeFlow next={HOUSING_LINK} previous={PROFILE_LINK} subTab={subTab} />
        case 'portfolio':
            return <PortfolioFlow />
        case 'cashflow':
            return <CashFlow />
        case 'account':
            return <Account />;
        default:
            return <div></div>
    }
}

const Profile = ({ profileFlowFinished, flowStatus, submitData }) => {
    return profileFlowFinished ? <div style={{ display: 'flex' }}>
        <div style={{ width: '200px' }}>
            <Sidebar submitData={submitData} flowStatus={flowStatus} />
        </div>
        <LLTabs flowStatus={flowStatus} />
    </div> :
        <OnboardingFlowView />
}

export default connect(state => ({
    profileFlowFinished: state.userData.flows && state.userData.flows.profile === 'finished',
    flowStatus: state.userData.flows,
}), {
    setFlowStatus,
    submitData
})(Profile);